import React from "react";
import "./FileStats.css";
import { Button } from "primereact/button";

const FileStatsBulkUpdate = ({
  data,
  header,
  setShowStats,
  setFileUploadDetails,
  duplicateRows,
  color,
}) => {
  /** UNIVERSAL ROW RENDERER */
  const renderDataRow = (item, index) => {
    // 1) notFound structure: { row: { ... }, reason: "..." }
    if (item?.row && typeof item.row === "object" && item?.reason) {
      return (
        <div key={index} className="dataRow">
          {Object.entries(item.row).map(([key, value]) => (
            <p key={key}>
              <strong>{key}:</strong> {value}
            </p>
          ))}
          <p style={{ color: "#B3261E" }}>
            <strong>Reason:</strong> {item.reason}
          </p>
        </div>
      );
    }

    // 2) mapping structure: { lookup: "...", updatedTo: "...", updatedFields: { ... } }
    // 2) mapping structure
    if (item?.lookup && item?.updatedTo) {
      return (
        <div key={index} className="dataRow">
          <p>
            <strong>Lookup:</strong> {item.lookup}
          </p>
          <p>
            <strong>Updated To:</strong> {item.updatedTo}
          </p>

          {item.updatedFields && (
            <div className="updatedFields">
              {Object.entries(item.updatedFields).map(([k, v]) => (
                <p key={k}>
                  <strong>{k}:</strong> {v}
                </p>
              ))}
            </div>
          )}

          {/* SEPARATOR LINE */}
          <div
            style={{
              width: "100%",
              height: "1px",
              background: "#E0E0E0",
              margin: "12px 0",
            }}
          ></div>
        </div>
      );
    }

    // 3) validationErrors structure: { row: <number>, reason: "..." }
    //    (explicitly check for numeric row)
    if (
      (typeof item?.row === "number" || /^\d+$/.test(String(item?.row))) &&
      item?.reason &&
      // ensure it's not the object-form notFound handled above
      !(typeof item.row === "object")
    ) {
      return (
        <div key={index} className="dataRow">
          <p>
            <strong>Row:</strong> {item.row}
          </p>
          <p style={{ color: "#B3261E" }}>
            <strong>Reason:</strong> {item.reason}
          </p>
        </div>
      );
    }

    // 4) duplicateRows or generic object
    if (typeof item === "object") {
      return (
        <div key={index} className="dataRow">
          {Object.keys(item).map((key) => (
            <p key={key}>
              <strong>{key}:</strong> {String(item[key])}
            </p>
          ))}
        </div>
      );
    }

    // 5) simple text/number rows
    return <p key={index}>{String(item)}</p>;
  };

  /** Decide what to display (fallback to duplicateRows) */
  const displayData = data?.length > 0 ? data : duplicateRows || [];

  return (
    <div className="filestats">
      <div className="filestatsinner">
        <button
          className="backicon"
          onClick={() => {
            setShowStats(false);
            setFileUploadDetails(true);
          }}
        >
          <i
            className="pi pi-angle-left"
            style={{ fontSize: "1.5rem", color: "#323232" }}
          ></i>
        </button>

        <h1>
          {header}:{" "}
          <span style={{ color: color === "success" ? "#27AE60" : "#B3261E" }}>
            {displayData.length}
          </span>
        </h1>

        <div className="datamain">
          {displayData.length > 0 ? (
            <div className="data">
              {displayData.map((item, index) => renderDataRow(item, index))}
            </div>
          ) : (
            <p>No data available</p>
          )}
        </div>

        <div className="filestatsbtn">
          <Button
            label="Back"
            className="backbtn"
            onClick={() => {
              setShowStats(false);
              setFileUploadDetails(true);
            }}
          />
          <Button label="Submit" className="nextbtn" />
        </div>
      </div>
    </div>
  );
};

export default FileStatsBulkUpdate;
